export default {"src":"/_next/static/media/v1.3acd7939.svg","height":130,"width":332};